import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useParams } from "react-router-dom";
import LoadingScreen from '../../components/LoadingScreen'
// import { Grid, MenuItem, Box, Button, TextField, Modal } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Paper, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import "./style.module.css";
// import WebRTCPlayer from './stream';
import ApiConfig from '../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import Robot from './robot'
import {Tasks} from './tasks'
import { Tasklists } from './tasklists';
import { Missions } from './missions';
import RobotScheduler from './schedular_page';
import Config from '../../config';
import { WebRTCCameraPlayer, shouldUseWebRTCReaderForStream, sanitizeUrl, isMixedContent } from '../../utils/webrtc';
import decodeJWT from '../../utils/JWTDecoder';
import { formatLocalDateTime } from '../../utils/dateTime';
import InteractiveRobotMapCanvas from './InteractiveRobotMapCanvas';
import PointTaskSelector from '../../components/navigation/PointTaskSelector';
import ActiveMissionPanel from '../../components/navigation/ActiveMissionPanel';
import { useMountEffect } from '../../utils/hooks';
import useActiveRobotMission from '../../utils/useActiveRobotMission';
import { snapshotRoutePreviewTarget } from '../../utils/navigationTarget';

export default function Robot_Component(props) {
    const [robot, setRobot] = useState(new Robot())
    const location = useLocation();
    const [livestream_info, setLivestreamInfo] = useState([])
    const [start_livestream, setStartLivestream] = useState(false)
    const { name } = useParams();
    // console.log(name)
    props = location.state;
    // console.log(props)
    const { keycloak } = useKeycloak();
    const a = new ApiConfig(keycloak)
    const apiConfig = a.api()
    const [broadcast_message, setBroadcastMessage] = useState("")
    const [map_image, setMapImage] = useState("")
    const [map_name, setMapName] = useState("")
    const [map_id, setMapId] = useState("")
    const [mapPointTarget, setMapPointTarget] = useState(null)
    const [routePreview, setRoutePreview] = useState(null)
    const [routeState, setRouteState] = useState("idle")
    const [routeError, setRouteError] = useState("")
    const routeRequestRef = useRef(0)
    const apiConfigRef = useRef(apiConfig)
    apiConfigRef.current = apiConfig
    const [waypoints, setWaypoints] = useState([])
    const [selected_waypoint, setSelectedWaypoint] = useState("")
    const [pendingWaypoint, setPendingWaypoint] = useState(null)
    const [pendingMapPoint, setPendingMapPoint] = useState(null)
    const [pointTaskIds, setPointTaskIds] = useState([])
    const [robot_status, setRobotStatus] = useState({})
    const [robot_lasers, setRobotLaser] = useState({})
    const [, setRobotMaps] = useState([])
    const [loading, setLoading] = useState(true);
    const wsRef = useRef(null);
    const {
        activeMission,
        loading: missionStateLoading,
        error: missionStateError,
        controlAction: missionControlAction,
        refresh: refreshActiveMission,
        controlMission,
    } = useActiveRobotMission(apiConfig, robot.info.Id)
    const hadActiveMissionRef = useRef(false)
    const missionStateLocked = Boolean(robot.info.Id) && (
        missionStateLoading || Boolean(missionStateError) || Boolean(activeMission)
    )
    const navigationLocked = missionStateLocked || routeState === 'dispatching'
    const previewTargetX = mapPointTarget?.x
    const previewTargetY = mapPointTarget?.y
    const previewTargetZ = mapPointTarget?.z
    const previewTargetHeading = mapPointTarget?.angle
    const activeMissionPath = String(activeMission?.mapId || '') === String(map_id || '')
        ? activeMission?.path || []
        : []
    const activeMissionRouteState = activeMission?.status === 'PAUSED'
        ? 'paused'
        : activeMission?.status === 'IN_PROGRESS'
            ? 'travelling'
            : 'scheduled'


    // TO BE REDO WITH PROPER PERMISSION AND RBAC
    const decoded = decodeJWT(keycloak.token)
    const roles = decoded.resource_access.frontend?.roles
    const isAdmin = roles.includes("admin")

    const getRobotInfoById = (robot_info) => {
        Promise.all([
          apiConfig.fetchRobotType(robot_info.RobotTypeId),
          apiConfig.fetchRobotSite(robot_info.RobotSiteId),
          apiConfig.fetchRobotSoftwareVersion(robot_info.RobotSoftwareId),
          apiConfig.fetchRobotVersion(robot_info.RobotVersionId),
          apiConfig.fetchRobotStatus(robot_info.Id),
        ]).then(results => {
          robot_info["Type"] = results[0].RobotResponse
          robot_info["Site"] = results[1].RobotResponse.Site
          robot_info["Software"] = results[2].RobotResponse.Version
          robot_info["RobotVersion"] = results[3].RobotResponse.Version
          var robot = new Robot()
          robot.info = robot_info
          robot.status = results[4].RobotResponse
          // console.log(robot)
          setRobot(robot)
          getRobotInit(robot)
        }).catch(error => {
          console.error(error);
        });
      }

    const retrieveRobot = () => {
        Promise.all([
          apiConfig.fetchRobotData(0)
        ]).then(results => {
          var robot_table = results[0].RobotResponse
        //   console.log(robot_table)
          for(let i = 0; i < robot_table.length; i++) {
            if(robot_table[i].RobotId === name){
                getRobotInfoById(robot_table[i])
                break;
            }
          }
        }).catch(error => {
            console.error(error);
        });
      }


    useEffect(() => {
        if (!robot.info.Id) return;

        const ws = new WebSocket(Config.robot_status_ws);
        wsRef.current = ws;

        ws.onopen = () => {
            console.log('Robot detail WebSocket connection established.');
        };

        ws.onclose = (event) => {
            console.log('Robot detail WebSocket connection closed.', event.code, event.reason);
        };

        ws.onerror = (error) => {
            console.error('Robot detail WebSocket error:', error);
        };

        ws.onmessage = (event) => {
            try {
                const obj = JSON.parse(event.data);
                if (!obj.data || obj.data.RobotTableId !== robot.info.Id) {
                    return;
                }

                if (obj.type === "status") {
                    setRobotStatus(obj.data);
                    setRobot((prevRobot) => ({ ...prevRobot, status: obj.data }));
                } else if (obj.type === "laser") {
                    setRobotLaser(obj.data);
                    setRobot((prevRobot) => ({ ...prevRobot, laser: obj.data }));
                }
            } catch (error) {
                console.error('Robot detail WebSocket message parse error:', error);
            }
        };

        return () => {
            ws.close();
            wsRef.current = null;
        };
    }, [robot.info.Id]);

    const sendRobotCommand = (payload) => {
        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
            console.warn('Robot detail WebSocket is not connected. Command was not sent.', payload);
            return;
        }
        wsRef.current.send(JSON.stringify(payload));
    };

    const getRobotWaypoints = (map_name) => {
        Promise.all([
            apiConfig.fetchWaypoints(map_name),
        ]).then(results => {
            setWaypoints(results[0].RobotResponse)
        }).catch(error => {
            console.error(error);
        });
    }

    const getRobotInit = (robot) => {
        Promise.all([
            apiConfig.fetchAllMaps(robot.info.Id),
            apiConfig.fetchLivestreamInfoByRobotId(robot.info.Id),
        ]).then(results => {
            console.log(results)
            results[0].RobotResponse.forEach(m => {
                if(String(m.Id) === String(robot.status.RobotMapId)){
                    getRobotWaypoints(m.Id)
                    setMapImage(m.Base64)
                    setMapName(m.MapName)
                    setMapId(m.Id)
                }
            })
            setRobotMaps(results[0].RobotResponse)

            // Sanitize livestream URLs to remove embedded credentials
            const sanitizedLivestreams = results[1].RobotResponse.map(stream => ({
                ...stream,
                RawUrl: stream.Url || '',
                Url: sanitizeUrl(stream.Url)
            }));
            setLivestreamInfo(sanitizedLivestreams);
            setLoading(false);
        }).catch(error => {
            console.error(error);
        });
      }

    // useEffect(()=>{

    //     window.addEventListener("scroll",() => {
    //         if(window.scrollY > 0 || window.scrollX > 0) {
    //           setYoffSet(window.scrollY)
    //           setXoffSet(window.scrollX)
    //         }
    //     })

    // }, [yOffSet, xOffSet, robot, robot_status, robot_lasers, robot_maps])

    useMountEffect(() => {

        // if(props == null || props == undefined){
        //     retrieveRobot()
        // } else {
        //     // console.log(props)
        //     setRobot(props.robot_details)
        //     getRobotInit(props.robot_details)
        // }

        retrieveRobot()

        return () => {
            // This code runs when the component is unmounted
            // Perform cleanup or unsubscribe from resources
            // console.log("Disconnecting from websocket...")
            // socket.close()
        };

    }, []);

    const moveRobotToWaypoint = (waypointName) => {
        if (!waypointName) return;
        console.log(`Robot going to ${waypointName}...`)
        sendRobotCommand({ action: 'gotogoal', value: waypointName, robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleGoWaypoint = () => {
        moveRobotToWaypoint(selected_waypoint)
    }

    const handleMapWaypointClick = (waypoint) => {
        if (!waypoint?.WaypointName) return;
        setSelectedWaypoint(waypoint.WaypointName)
        setPendingWaypoint(waypoint)
    }

    const handleConfirmMapWaypoint = () => {
        const waypointName = pendingWaypoint?.WaypointName;
        setPendingWaypoint(null)
        moveRobotToWaypoint(waypointName)
    }

    useEffect(() => {
        if (activeMission) {
            hadActiveMissionRef.current = true
            routeRequestRef.current += 1
            setPendingMapPoint(null)
            setPointTaskIds([])
            setRoutePreview(null)
            setRouteState(
                activeMission.status === 'PAUSED'
                    ? 'paused'
                    : activeMission.status === 'IN_PROGRESS'
                        ? 'travelling'
                        : 'scheduled'
            )
            setRouteError('')
            return
        }

        if (hadActiveMissionRef.current) {
            hadActiveMissionRef.current = false
            setMapPointTarget(null)
            setRoutePreview(null)
            setRouteState('idle')
            setRouteError('')
        }
    }, [activeMission])

    useEffect(() => {
        if (navigationLocked) return undefined
        if (
            !Number.isFinite(previewTargetX)
            || !Number.isFinite(previewTargetY)
            || !robot.info.Id
            || !map_id
        ) {
            routeRequestRef.current += 1
            setRoutePreview(null)
            setRouteState('idle')
            setRouteError('')
            return undefined
        }

        const requestId = routeRequestRef.current + 1
        routeRequestRef.current = requestId
        const controller = new AbortController()
        setRouteState('calculating')
        setRouteError('')
        const timer = window.setTimeout(() => {
            apiConfigRef.current.previewNavigationRoute(robot.info.Id, map_id, {
                x: previewTargetX,
                y: previewTargetY,
                z: previewTargetZ,
                heading: previewTargetHeading,
            }, { signal: controller.signal }).then((response) => {
                if (routeRequestRef.current !== requestId) return
                setRoutePreview(response.RobotResponse)
                setRouteState('ready')
            }).catch((error) => {
                if (controller.signal.aborted || error?.name === 'AbortError') return
                if (routeRequestRef.current !== requestId) return
                setRoutePreview(null)
                setRouteState('error')
                setRouteError(error?.response?.data?.Message || error.message || 'Unable to calculate route')
            })
        }, 250)

        return () => {
            window.clearTimeout(timer)
            controller.abort()
        }
    }, [
        previewTargetX, previewTargetY, previewTargetZ, previewTargetHeading,
        map_id, robot.info.Id, navigationLocked,
    ])

    const handleMapPointTargetChange = (target) => {
        if (navigationLocked) return
        setMapPointTarget((currentTarget) => (
            snapshotRoutePreviewTarget(target, currentTarget, robot_status.LocationZ)
        ))
    }
    const handleMapPointClick = (target, clearTarget) => {
        if (!target || navigationLocked) return;
        setPointTaskIds([])
        setPendingMapPoint({ ...target, clearTarget })
    }

    const handleCloseMapPointDialog = () => {
        if (routeState === 'dispatching') return
        setPendingMapPoint(null)
        setPointTaskIds([])
    }

    const handleConfirmMapPoint = () => {
        if (!pendingMapPoint || !routePreview?.routePlanId || routeState !== 'ready' || navigationLocked) return;
        setRouteState('dispatching')
        setRouteError('')
        apiConfig.dispatchNavigationRoute(routePreview.routePlanId, pointTaskIds).then(async () => {
            setPendingMapPoint(null)
            setPointTaskIds([])
            setRouteState('scheduled')
            await refreshActiveMission()
        }).catch((error) => {
            setRouteState('error')
            setRouteError(error?.response?.data?.Message || error.message || 'Unable to dispatch route')
        })
    }

    const handleStop = () =>{
        console.log("Stopping robot...")
        sendRobotCommand({ action: 'stop', value: "", robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleMissionPause = () =>{
        controlMission('pause')
    }

    const handleMissionResume = () =>{
        controlMission('resume')
    }

    const handleMissionStop = () =>{
        controlMission('cancel')
    }

    const handleFront = () =>{
        console.log("Moving robot forward...")
        sendRobotCommand({ action: 'gotodirection', value: "front", robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleLeft = () =>{
        console.log("Turning robot left...")
        sendRobotCommand({ action: 'gotodirection', value: "left", robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleRight = () =>{
        console.log("Turning robot right...")
        sendRobotCommand({ action: 'gotodirection', value: "right", robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleBack = () =>{
        console.log("Moving robot backward...")
        sendRobotCommand({ action: 'gotodirection', value: "back", robot_name: robot.info.RobotId, instruction: 'movement'})
    }

    const handleBroadcastMessage = () => {
        console.log("Broadcasting", broadcast_message)
        sendRobotCommand({ message: broadcast_message, speed: 'default', robot_name: robot.info.RobotId, instruction: 'broadcast'})
    }

    const handleStartLivestream = () => {
        setStartLivestream(true)
        console.log(livestream_info)
        let data = {
            "robot_id": robot.info.RobotId,
            "action": "start"
        }
        apiConfig.activateLivestream(data).then((response)=>{
            console.log(response)
        })
    }

    const handleStopLivestream = () => {
        setStartLivestream(false)
        let data = {
            "robot_id": robot.info.RobotId,
            "action": "stop"
        }
        apiConfig.activateLivestream(data).then((response)=>{
            console.log(response)
        })
    }

        if (loading) {
        return (
            <LoadingScreen open={loading}/>
        );
    }
    return(
        <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh', padding: '24px' }}>
            <Grid container spacing={3}>
                {/* Robot Details Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Robot Details
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                        {[
                                            { label: 'Name', value: robot.info.RobotId },
                                            { label: 'Type', value: robot.info.Type?.Name },
                                            { label: 'Site', value: robot.info.Site },
                                            { label: 'Version', value: robot.info.RobotVersion },
                                            { label: 'Software', value: robot.info.Software },
                                            { label: 'Fabrication Date', value: robot.info.FabricationDate },
                                            { label: 'Status', value: robot.info.ActivationStatus ? 'Activated' : 'Not Activated' },
                                        ].map((item, idx) => (
                                            <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                <Typography sx={{ fontWeight: '600', color: 'text.primary' }}>{item.label}:</Typography>
                                                <Typography sx={{ color: 'text.secondary' }}>{item.value}</Typography>
                                            </Box>
                                        ))}
                                        <Button
                                            variant="contained"
                                            sx={{ marginTop: '16px' }}
                                            onClick={() => {
                                                apiConfig.activateRobot(robot.info.RegistrationKey).then(() => window.location.reload())
                                            }}
                                        >
                                            Activate Robot
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img style={{ maxHeight: '300px', maxWidth: '100%', objectFit: 'contain' }}
                                        src={`data:image/jpeg;base64,${robot.info.Type?.Image}`} alt="Robot" />
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

                {/* Robot Status Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Robot Status
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            {/* Battery Level */}
                            <Box sx={{ marginBottom: 3 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: 1 }}>
                                    <Typography sx={{ fontWeight: '600' }}>Battery Level</Typography>
                                    <Chip label={`${robot_status.BatteryLevel}%`} size="small" />
                                </Box>
                                <Box sx={{
                                    height: '12px',
                                    borderRadius: '6px',
                                    bgcolor: 'var(--muted-bg, #e0e0e0)',
                                    overflow: 'hidden'
                                }}>
                                    <Box sx={{
                                        height: '100%',
                                        width: `${robot_status.BatteryLevel}%`,
                                        background: robot_status.BatteryLevel > 50 ? '#27ae60' : robot_status.BatteryLevel > 35 ? '#f39c12' : '#e74c3c',
                                        transition: 'width 0.3s ease'
                                    }} />
                                </Box>
                            </Box>

                            <Grid container spacing={2}>
                                {[
                                    { label: 'Charging', value: robot_status.Charging ? 'Yes' : 'No' },
                                    { label: 'Temperature', value: `${robot_status.BatteryTemperature}°C` },
                                    { label: 'Status', value: robot_status.Status },
                                    { label: 'Map', value: map_name },
                                    { label: 'Task', value: robot_status.RobotTask },
                                    { label: 'Location', value: robot_status.Location },
                                    { label: 'X', value: robot_status.LocationX },
                                    { label: 'Y', value: robot_status.LocationY },
                                    { label: 'Angle', value: `${robot_status.Angle}°` },
                                    { label: 'Localised', value: robot_status.Localisation ? 'Yes' : 'No' },
                                ].map((item, idx) => (
                                    <Grid item xs={6} sm={4} md={3} key={idx}>
                                        <Paper sx={{ padding: 1.5, textAlign: 'center', backgroundColor: 'background.default' }}>
                                            <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', fontWeight: '600' }}>
                                                {item.label}
                                            </Typography>
                                            <Typography sx={{ fontWeight: '700', marginTop: 0.5 }}>
                                                {item.value}
                                            </Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                            <Box sx={{ marginTop: 2, padding: 1.5, backgroundColor: 'action.hover', borderRadius: '6px' }}>
                                <Typography sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
                                    Last Updated: {formatLocalDateTime(robot_status.CreatedAt) || 'N/A'}
                                </Typography>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>

                {/* Robot Map Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Robot Location Map
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px', position: 'relative' }}>
                            <InteractiveRobotMapCanvas
                                mapImage={map_image}
                                waypoints={waypoints}
                                robotStatus={robot_status}
                                laserPoints={robot_lasers.RobotLaser || []}
                                robotName={robot.info.RobotId}
                                selectedWaypointName={selected_waypoint}
                                onWaypointClick={handleMapWaypointClick}
                                onPointTargetClick={handleMapPointClick}
                                onPointTargetChange={handleMapPointTargetChange}
                                routePoints={activeMission ? activeMissionPath : routePreview?.geometry || routePreview?.points || []}
                                routeState={activeMission ? activeMissionRouteState : routeState}
                                targetLocked={navigationLocked}
                                missionStatus={activeMission?.status || ''}
                                missionTarget={activeMission?.missionType === 'temporary-point' ? activeMission.target : null}
                            />
                            <ActiveMissionPanel
                                mission={activeMission}
                                error={missionStateError}
                                controlAction={missionControlAction}
                                onPause={() => controlMission('pause')}
                                onResume={() => controlMission('resume')}
                                onCancel={() => controlMission('cancel')}
                                sx={{ bottom: 36 }}
                            />
                        </Box>
                    </Paper>
                    <Dialog
                        open={Boolean(pendingWaypoint)}
                        onClose={() => setPendingWaypoint(null)}
                        aria-labelledby="confirm-waypoint-title"
                    >
                        <DialogTitle id="confirm-waypoint-title">Move robot to waypoint?</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Move {robot.info.RobotId} to <strong>{pendingWaypoint?.WaypointName}</strong>?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setPendingWaypoint(null)}>Cancel</Button>
                            <Button variant="contained" onClick={handleConfirmMapWaypoint} autoFocus>
                                Move Robot
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={Boolean(pendingMapPoint)}
                        onClose={handleCloseMapPointDialog}
                        aria-labelledby="confirm-map-point-title"
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle id="confirm-map-point-title">Move robot to map point?</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Move {robot.info.RobotId} to map pixel{' '}
                                <strong>
                                    ({Math.round(pendingMapPoint?.x || 0)}, {Math.round(pendingMapPoint?.y || 0)})
                                </strong>{' '}
                                with heading{' '}
                                <strong>
                                    {Math.round(((pendingMapPoint?.angle || 0) * 180) / Math.PI)} degrees
                                </strong>?
                                {routeState === "calculating" && <><br />Calculating the safest waypoint route...</>}
                                {routePreview && <><br />Route uses {routePreview.points.filter((point) => point.type === "waypoint").length} waypoint(s), approximately {Math.round(routePreview.estimatedDistance)} map pixels.</>}
                                {routeError && <><br /><strong>{routeError}</strong></>}
                            </DialogContentText>
                            <PointTaskSelector
                                apiConfig={apiConfig}
                                open={Boolean(pendingMapPoint)}
                                selectedTaskIds={pointTaskIds}
                                onChange={setPointTaskIds}
                                disabled={routeState === 'dispatching'}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseMapPointDialog} disabled={routeState === 'dispatching'}>Cancel</Button>
                            <Button variant="contained" color="secondary" onClick={handleConfirmMapPoint} disabled={routeState !== "ready"} autoFocus>
                                {pointTaskIds.length ? 'Move & Run Tasks' : 'Move Robot'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Grid>

                {/* Pilot Controls Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Pilot Controls
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            <Grid container spacing={2} sx={{ marginBottom: 3 }}>
                                {/* Direction Controls */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: '600', marginBottom: 2 }}>Navigation</Typography>
                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
                                        <Box />
                                        <Button fullWidth variant="contained" color="secondary"
                                            onPointerDown={handleFront} onPointerUp={handleStop}>
                                            ▲
                                        </Button>
                                        <Box />

                                        <Button fullWidth variant="contained" color="secondary"
                                            onPointerDown={handleLeft} onPointerUp={handleStop}>
                                            ◄
                                        </Button>
                                        <Button fullWidth variant="contained" color="error" onClick={handleStop}>
                                            STOP
                                        </Button>
                                        <Button fullWidth variant="contained" color="secondary"
                                            onPointerDown={handleRight} onPointerUp={handleStop}>
                                            ►
                                        </Button>

                                        <Box />
                                        <Button fullWidth variant="contained" color="secondary"
                                            onPointerDown={handleBack} onPointerUp={handleStop}>
                                            ▼
                                        </Button>
                                        <Box />
                                    </Box>
                                </Grid>

                                {/* Mission Controls */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: '600', marginBottom: 2 }}>Mission</Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <Button fullWidth variant="contained" sx={{ backgroundColor: '#27ae60' }} onClick={handleMissionResume}>
                                            Resume
                                        </Button>
                                        <Button fullWidth variant="contained" sx={{ backgroundColor: '#f39c12' }} onClick={handleMissionPause}>
                                            Pause
                                        </Button>
                                        <Button fullWidth variant="outlined" color="error" onClick={handleMissionStop}>
                                            Stop
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Waypoint Selection */}
                            <Divider sx={{ marginY: 2 }} />
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', marginBottom: 2 }}>Go to Waypoint</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Select Waypoint"
                                        value={selected_waypoint}
                                        onChange={(e)=>setSelectedWaypoint(e.target.value)}
                                        size="small"
                                    >
                                        {waypoints.map((waypoint, index)=>(
                                            <MenuItem key={index} value={waypoint.WaypointName}>{waypoint.WaypointName}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Button fullWidth variant="contained" onClick={handleGoWaypoint} disabled={!selected_waypoint}>
                                        Go
                                    </Button>
                                </Grid>
                            </Grid>

                            {/* Broadcast Message */}
                            <Divider sx={{ marginY: 2 }} />
                            <Typography variant="subtitle2" sx={{ fontWeight: '600', marginBottom: 2 }}>Broadcast Message</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                    <TextField
                                        fullWidth
                                        label="Message"
                                        value={broadcast_message}
                                        onChange={(event)=>setBroadcastMessage(event.target.value)}
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Button fullWidth variant="contained" onClick={handleBroadcastMessage}>
                                        Send
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

                {/* Livestream Card */}
                {isAdmin ?
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Robot Stream
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                                <Grid item xs={6}>
                                    <Button fullWidth variant="contained" sx={{ backgroundColor: '#27ae60' }} onClick={handleStartLivestream}>
                                        Start Stream
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button fullWidth variant="outlined" color="error" onClick={handleStopLivestream}>
                                        Stop Stream
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                {start_livestream && livestream_info.length>0?
                                    livestream_info.map((info, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Paper sx={{ borderRadius: '8px', overflow: 'hidden' }}>
                                                <Box sx={{ width: '100%', height: '250px', backgroundColor: '#000' }}>
                                                    {(info.RawUrl || info.Url) && !isMixedContent(info.RawUrl || info.Url) ? (
                                                        shouldUseWebRTCReaderForStream(info.RawUrl || info.Url, info) ? (
                                                            <WebRTCCameraPlayer
                                                                url={info.RawUrl || info.Url}
                                                                title={info.CameraPosition}
                                                                token={keycloak.token}
                                                                streamAuth={info}
                                                                muted
                                                                fetchBearerToken={apiConfig.fetchLivestreamBearerToken}
                                                            />
                                                        ) : (
                                                            <Box
                                                                component="iframe"
                                                                src={info.Url}
                                                                title={info.CameraPosition}
                                                                sx={{ width: '100%', height: '100%', border: 'none' }}
                                                                allow="autoplay; fullscreen; picture-in-picture"
                                                            />
                                                        )
                                                    ) : (info.RawUrl || info.Url) && isMixedContent(info.RawUrl || info.Url) ? (
                                                        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '8px', color: '#f59e0b', textAlign: 'center' }}>
                                                            <Typography sx={{ fontSize: '0.8rem' }}>Mixed content blocked</Typography>
                                                            <Box
                                                                component="a"
                                                                href={info.RawUrl || info.Url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{ color: '#2196F3', fontSize: '0.75rem' }}
                                                            >
                                                                Open stream
                                                            </Box>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#666' }}>
                                                            No stream URL
                                                        </Box>
                                                    )}
                                                </Box>
                                                <Box sx={{ padding: 1.5, backgroundColor: 'background.default' }}>
                                                    <Typography sx={{ fontSize: '0.85rem', fontWeight: '600' }}>{info.CameraPosition}</Typography>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    ))
                                    : <Grid item xs={12}><Typography sx={{ color: 'text.disabled' }}>Start livestream to view camera feeds</Typography></Grid>
                                }
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
                : null}

                {/* Missions Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Missions
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            <Grid container spacing={2}>
                                <Tasks/>
                                <Tasklists/>
                                <Missions robotId={robot.info.Id}/>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>

                {/* Schedules Card */}
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                        <Box sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', padding: '20px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                Schedules
                            </Typography>
                        </Box>
                        <Box sx={{ padding: '24px' }}>
                            <RobotScheduler robotId={robot.info.Id} robotName={robot.info.RobotId}/>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    )
}


// import React, { useEffect, useState, useRef } from 'react';
// import { useLocation, useParams, useNavigate } from "react-router-dom";
// import useForm from './form'
// // import { Grid, MenuItem, Box, Button, TextField, Modal } from '@material-ui/core';
// import MenuItem from '@mui/material/MenuItem';
// import Grid from '@mui/material/Grid';
// import Select from '@mui/material/Select';
// import { Tabs, Tab} from '@mui/material';
// import Box from '@mui/material/Box';
// import BoltIcon from '@mui/icons-material/Bolt';
// import { CircularProgress, Container } from '@mui/material';
// import Button from '@mui/material/Button';
// import TextField from '@mui/material/TextField';
// import Divider from '@mui/material/Divider';
// import Accordion from '@mui/material/Accordion';
// import AccordionDetails from '@mui/material/AccordionDetails';
// import AccordionSummary from '@mui/material/AccordionSummary';
// import Typography from '@mui/material/Typography';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { Card } from 'antd';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // Import ArrowBackIcon for back button
// import Oscar from './images/oscar.png';
// import Casey from './images/casey.png';
// import Peter from './images/peter.png';
// // import WebRTCPlayer from './stream';
// import ApiConfig from '../../utils/services/apiConfig'
// import { useKeycloak } from '@react-keycloak/web';
// import Robot from './robot'
// import {Tasks} from './tasks'
// import { Tasklists } from './tasklists';
// import { Missions } from './missions';
// import MissionScheduler from './schedule';
// import MissionSchedulerRC2 from './schedule_rc2';
// import './robot_component_mobile.css';
// import Config from '../../config';

// const socket = new WebSocket(Config.robot_status_ws);
// export default function Robot_Component(props) {
//     const [robot, setRobot] = useState(new Robot())
//     const [tabValue, setTabValue] = useState(0);  // State to manage selected tab
//     const location = useLocation();
//     const [livestream_info, setLivestreamInfo] = useState([])
//     const [start_livestream, setStartLivestream] = useState(false)
//     const { name } = useParams();
//     const navigate = useNavigate(); // Added useNavigate
//     // console.log(name)
//     props = location.state;
//     // console.log(props)
//     const { keycloak } = useKeycloak();
//     const a = new ApiConfig(keycloak)
//     const apiConfig = a.api()
//     const [broadcast_message, setBroadcastMessage] = useState("")
//     const [map_image, setMapImage] = useState("")
//     const [map_name, setMapName] = useState("")

//     const [waypoints, setWaypoints] = useState([])
//     const [selected_waypoint, setSelectedWaypoint] = useState("")
//     const [current_laser, setCurrentLaser] = useState(null)
//     const divRef = useRef(null)
//     const gridRef = useRef(null)
//     const [robot_status, setRobotStatus] = useState({})
//     const [robot_lasers, setRobotLaser] = useState({})
//     const [robot_maps, setRobotMaps] = useState([])
//     const [loading, setLoading] = useState(true);

//     const [yOffSet, setYoffSet] = useState('')
//     const [xOffSet, setXoffSet] = useState('')


//     // Handle Tab Change
//     const handleTabChange = (event, newValue) => {
//             setTabValue(newValue);
//     };

//       // Handle back button click
//       const handleBackButton = () => {
//         navigate(-1); // This navigates directly to the previous page
//       };


//     const getRobotInfoById = (robot_info) => {
//         Promise.all([
//           apiConfig.fetchRobotType(robot_info.RobotTypeId),
//           apiConfig.fetchRobotSite(robot_info.RobotSiteId),
//           apiConfig.fetchRobotSoftwareVersion(robot_info.RobotSoftwareId),
//           apiConfig.fetchRobotVersion(robot_info.RobotVersionId),
//           apiConfig.fetchRobotStatus(robot_info.Id),
//         ]).then(results => {
//           robot_info["Type"] = results[0].RobotResponse.Type
//           robot_info["Site"] = results[1].RobotResponse.Site
//           robot_info["Software"] = results[2].RobotResponse.Version
//           robot_info["RobotVersion"] = results[3].RobotResponse.Version
//           var robot = new Robot()
//           robot.info = robot_info
//           robot.status = results[4].RobotResponse
//           console.log(robot)
//           setRobot(robot)
//           getRobotInit(robot)
//         }).catch(error => {
//           console.error(error);
//         });
//       }

//     const retrieveRobot = () => {
//         Promise.all([
//           apiConfig.fetchRobotData(0)
//         ]).then(results => {
//           var robot_table = results[0].RobotResponse
//          console.log(robot_table)
//           for(let i = 0; i < robot_table.length; i++) {
//             if(robot_table[i].RobotId === name){
//                 getRobotInfoById(robot_table[i])
//                 break;
//             }
//           }
//         }).catch(error => {
//             console.error(error);
//         });
//       }


//     socket.onopen = () => {
//         console.log('WebSocket connection established.');
//     };
//     socket.onclose = () => {
//         console.log('Websocket connection closed.')
//     }
//     socket.onmessage = (event) => {
//         const obj = JSON.parse(event.data);
//         // console.log('Received status:', obj);
//         if(obj.type == "status"){
//             // console.log(obj.data)
//             try {
//                 if (!obj.data){
//                     return 0;
//                 }
//                 if(obj.data.RobotTableId == robot.info.Id){
//                     setRobotStatus(obj.data)
//                     robot.status = obj.data
//                 }
//             } catch (error) {
//                 console.log(error)
//                 // if(obj.data.RobotTableId == name){
//                 //     setRobotStatus(obj.data)
//                 //     robot.status = obj.data
//                 // }
//             }
//         } else if(obj.type == "laser"){
//             // console.log(obj.data)
//             try {
//                 if (!obj.data){
//                     return 0;
//                 }
//                 if(obj.data.RobotTableId == robot.info.Id){
//                     setRobotLaser(obj.data)
//                     robot.laser = obj.data
//                 }
//             } catch (error) {
//                 console.log(error)
//                 // if(obj.data.RobotTableId == name){
//                 //     setRobotLaser(obj.data)
//                 //     robot.laser = obj.data
//                 // }
//             }
//         }
//       };

//     const getRobotWaypoints = (map_name) => {
//         Promise.all([
//             apiConfig.fetchWaypoints(map_name),
//         ]).then(results => {
//             setWaypoints(results[0].RobotResponse)
//         }).catch(error => {
//             console.error(error);
//         });
//     }

//     const getRobotInit = (robot) => {
//         Promise.all([
//             apiConfig.fetchAllMaps(robot.info.Id),
//             apiConfig.fetchLivestreamInfoByRobotId(robot.info.Id),
//         ]).then(results => {
//             results[0].RobotResponse.forEach(m => {
//                 if(m.Id == robot.status.RobotMapId){
//                     getRobotWaypoints(m.Id)
//                     setMapImage(m.Base64)
//                     setMapName(m.MapName)
//                 }
//             })
//             setRobotMaps(results[0].RobotResponse)
//             setLivestreamInfo(results[1].RobotResponse)
//             setLoading(false);
//         }).catch(error => {
//             console.error(error);
//         });
//       }


//     // useEffect(()=>{

//     //     window.addEventListener("scroll",() => {
//     //         if(window.scrollY > 0 || window.scrollX > 0) {
//     //           setYoffSet(window.scrollY)
//     //           setXoffSet(window.scrollX)
//     //         }
//     //     })

//     // }, [yOffSet, xOffSet, robot, robot_status, robot_lasers, robot_maps])

//     useEffect(() => {

//         if(props == null || props == undefined){
//             retrieveRobot()
//         } else {
//             // console.log(props)
//             setRobot(props.robot_details)
//             getRobotInit(props.robot_details)
//         }

//         return () => {
//             // This code runs when the component is unmounted
//             // Perform cleanup or unsubscribe from resources
//             // console.log("Disconnecting from websocket...")
//             // socket.close()
//         };

//     }, []);

//     const handleGoWaypoint = () =>{
//         console.log(`Robot going to ${selected_waypoint}...`)
//         socket.send(JSON.stringify({ action: 'gotogoal', value: selected_waypoint, robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handlePause = () =>{
//         console.log("Pausing robot...")
//         socket.send(JSON.stringify({ action: 'pause', value: "", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleResume = () =>{
//         console.log("Resuming robot...")
//         socket.send(JSON.stringify({ action: 'resume', value: "", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleStop = () =>{
//         console.log("Stopping robot...")
//         socket.send(JSON.stringify({ action: 'stop', value: "", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleFront = () =>{
//         console.log("Moving robot forward...")
//         socket.send(JSON.stringify({ action: 'gotodirection', value: "front", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleLeft = () =>{
//         console.log("Turning robot left...")
//         socket.send(JSON.stringify({ action: 'gotodirection', value: "left", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleRight = () =>{
//         console.log("Turning robot right...")
//         socket.send(JSON.stringify({ action: 'gotodirection', value: "right", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleBack = () =>{
//         console.log("Moving robot backward...")
//         socket.send(JSON.stringify({ action: 'gotodirection', value: "back", robot_name: robot.info.RobotId, instruction: 'movement'}))
//     }

//     const handleBroadcastMessage = () => {
//         console.log("Broadcasting", broadcast_message)
//         socket.send(JSON.stringify({ message: broadcast_message, speed: 'default', robot_name: robot.info.RobotId, instruction: 'broadcast'}))
//     }

//     const handleStartLivestream = () => {
//         setStartLivestream(true)
//         console.log(livestream_info)
//         let data = {
//             "robot_id": robot.info.RobotId,
//             "action": "start"
//         }
//         apiConfig.activateLivestream(data).then((response)=>{
//             console.log(response)
//         })
//     }

//     const handleStopLivestream = () => {
//         setStartLivestream(false)
//         let data = {
//             "robot_id": robot.info.RobotId,
//             "action": "stop"
//         }
//         apiConfig.activateLivestream(data).then((response)=>{
//             console.log(response)
//         })
//     }






//     const renderLivestream = (info, index) =>{
//         return(
//             <Grid item key={index} xs={12} sm={6} md={3} lg={3} xl={3}>
//                 {/* <WebRTCPlayer url={info.Url}/> */}
//                 <iframe src={info.Url}></iframe>
//                 <div>{info.CameraPosition}</div>
//             </Grid>
//         )
//     }
//     if (loading) {
//         return (
//             <Container>
//                 <CircularProgress />
//                 <Typography>Loading...</Typography>
//             </Container>
//         );
//     }





//     return(
// <Grid container spacing={4} className="mobile-section-container">

//   {/* Full Tabs for Larger Screens */}
//   <Box
//     sx={{
//       display: { xs: 'none', sm: 'flex' }, // Only visible on larger screens
//       width: '100%',
//       justifyContent: 'center',
//       alignItems: 'center',
//       backgroundColor: 'white',
//       padding: '10px 0',
//       boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
//     }}
//   >
//     <Tabs
//       value={tabValue}
//       onChange={handleTabChange}
//       variant="fullWidth" // Full-width tabs for larger screens
//       textColor="primary"
//       indicatorColor="primary"
//       sx={{
//         '& .MuiTab-root': {
//           fontSize: '16px', // Larger font for larger screens
//           minWidth: 'auto',
//           padding: '10px 16px',
//           textAlign: 'center',
//           justifyContent: 'center',
//           alignItems: 'center',
//         },
//       }}
//     >
//     <Tab label="Robot Details" sx={{ fontWeight: 'bold' }} />
//     <Tab label="Robot Status" sx={{ fontWeight: 'bold' }} />
//     <Tab label="Robot Stream" sx={{ fontWeight: 'bold' }} />
//     <Tab label="Pilot" sx={{ fontWeight: 'bold' }} />
//     <Tab label="Missions" sx={{ fontWeight: 'bold' }} />
//     <Tab label="Schedules" sx={{ fontWeight: 'bold' }} />
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: { xs: "center", sm: "space-between" }, // Center for mobile, space-between for larger screens
//         alignItems: "center",
//         padding: { xs: "8px 12px", sm: "8px 16px" },
//         backgroundColor: "white",
//         boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//         position: "sticky", // Sticky to stay visible at the top
//         top: 0,
//         zIndex: 1000,
//         flexWrap: { xs: "wrap", sm: "nowrap" }, // Wrap for smaller screens
//       }}
//     >
//       {/* Back Button with Logo */}
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleBackButton}
//         sx={{
//           padding: { xs: "4px 8px", sm: "6px 12px" },
//           fontSize: { xs: "12px", sm: "14px" },
//           borderRadius: "8px",
//           marginBottom: { xs: "8px", sm: "0" }, // Add bottom margin for mobile
//           minWidth: { xs: "auto", sm: "64px" }, // Ensure it doesn't collapse
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <ArrowBackIcon sx={{ fontSize: { xs: "16px", sm: "20px" } }} />
//       </Button>
//     </Box>
//     </Tabs>
//   </Box>



//       {/* Tab Contents */}
//       {tabValue === 0 && (
//   <Box
//     p={3}
//     sx={{
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       minHeight: '100vh', // Full height for vertical centering
//       width: '100%',
//     }}
//   >
//     <Grid
//       container
//       spacing={3}
//       sx={{
//         maxWidth: '1200px', // Limit the width for larger screens
//         width: '100%',
//         margin: '0 auto', // Center horizontally
//       }}
//     >
//       <Grid item xs={12}>
//         <Card
//           sx={{
//             borderRadius: '12px',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//             padding: '20px',
//           }}
//         >
//           <Typography
//             variant="h4"
//             align="center"
//             gutterBottom
//             sx={{
//               fontWeight: 'bold',
//               fontSize: {
//                 xs: 24,
//                 sm: 28,
//                 md: 36,
//               },
//             }}
//           >
//             Robot Details
//           </Typography>

//           <Grid container spacing={3}>
//             {/* Left Section - Robot Details */}
//             <Grid item xs={12} md={6}>
//               <div style={{ padding: '20px' }}>
//                 {[
//                   { label: 'Robot Name', value: robot.info.RobotId },
//                   { label: 'Robot Type', value: robot.info.Type },
//                   { label: 'Robot Site', value: robot.info.Site },
//                   { label: 'Robot Version', value: robot.info.RobotVersion },
//                   { label: 'Robot Software Version', value: robot.info.Software },
//                   { label: 'Robot Fabrication Date', value: robot.info.FabricationDate },
//                   { label: 'Robot Deployed Date', value: robot.info.DeployedDate },
//                   { label: 'Robot Decommission Date', value: robot.info.DecomDate },
//                   { label: 'Robot Registration Date', value: robot.info.RegistrationDate },
//                   {
//                     label: 'Robot Activation Status',
//                     value: robot.info.ActivationStatus ? 'Activated' : 'Not Activated',
//                   },
//                   { label: 'Robot Activation Key', value: robot.info.RegistrationKey },
//                 ].map((item, index) => (
//                   <Typography
//                     key={index}
//                     variant="body1"
//                     sx={{
//                       fontSize: '18px',
//                       fontWeight: 'bold',
//                       marginBottom: '8px',
//                     }}
//                   >
//                     {item.label}: {item.value}
//                   </Typography>
//                 ))}
//               </div>
//             </Grid>

//             {/* Right Section - Robot Image */}
//             <Grid item xs={12} md={6}>
//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   padding: '20px',
//                 }}
//               >
//                 <img
//                   style={{
//                     width: '100%',
//                     maxWidth: 400,
//                     height: 'auto',
//                   }}
//                   src={
//                     robot.info.Type === 'CS' || robot.info.Type === 'TS'
//                       ? Casey
//                       : robot.info.Type === 'OS'
//                       ? Oscar
//                       : Peter
//                   }
//                   alt="Robot Image"
//                 />
//               </div>
//             </Grid>
//           </Grid>
//         </Card>
//       </Grid>
//     </Grid>
//   </Box>
// )}





// {tabValue === 1 && (
//   <Box
//     p={3}
//     sx={{
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'center',
//       minHeight: '100vh', // Full height for vertical centering
//       width: '100%',
//     }}
//   >
//     <Grid
//       container
//       spacing={3}
//       sx={{
//         maxWidth: '1200px', // Limit the width for larger screens
//         width: '100%',
//         margin: '0 auto', // Center horizontally
//       }}
//     >
//       <Grid item xs={12}>
//         <Card
//           sx={{
//             borderRadius: '12px',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//             padding: '20px',
//           }}
//         >
//           <Typography
//             variant="h4"
//             align="center"
//             gutterBottom
//             sx={{
//               fontWeight: 'bold',
//               fontSize: {
//                 xs: 24,
//                 sm: 28,
//                 md: 36,
//               },
//             }}
//           >
//             Robot Status
//           </Typography>

//           <Grid container spacing={3}>
//             {/* Battery Level */}
//             <Grid item xs={12}>
//               <div
//                 style={{
//                   background: `linear-gradient(to right, ${
//                     robot_status.BatteryLevel <= 50 && robot_status.BatteryLevel > 35
//                       ? '#FFFF40'
//                       : robot_status.BatteryLevel <= 35
//                       ? '#FF5040'
//                       : '#40FF55'
//                   } 0%, grey 100%)`,
//                   height: 20,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   border: 'solid',
//                   borderRadius: 5,
//                   width: '100%',
//                   fontSize: '16px',
//                   fontWeight: 'bold',
//                 }}
//               >
//                 {robot_status.Charging ? <BoltIcon style={{ marginRight: '5px' }} /> : null}
//                 <div>{robot_status.BatteryLevel}%</div>
//               </div>
//             </Grid>

//             {/* Left Section - Robot Details */}
//             <Grid item xs={12} md={6}>
//               <div style={{ padding: '20px' }}>
//                 {[
//                   { label: 'Battery Temperature', value: robot_status.BatteryTemperature },
//                   { label: 'Charging', value: robot_status.Charging ? 'Charging' : 'Not Charging' },
//                   { label: 'Map Name', value: map_name },
//                   { label: 'Task', value: robot_status.RobotTask },
//                   { label: 'Status', value: robot_status.Status },
//                   { label: 'Location', value: robot_status.Location },
//                   { label: 'Location X', value: robot_status.LocationX },
//                   { label: 'Location Y', value: robot_status.LocationY },
//                   { label: 'Angle', value: robot_status.Angle },
//                   {
//                     label: 'Localisation',
//                     value: robot_status.Localisation ? 'Localised' : 'Mislocalised',
//                   },
//                   {
//                     label: 'Is Task Ended',
//                     value: robot_status.IsTaskEnded ? 'Task ended' : 'Task not ended',
//                   },
//                   { label: 'Estop', value: robot_status.Estop ? 'Engaged' : 'Released' },
//                   { label: 'Updated', value: robot_status.CreatedAt },
//                 ].map((item, index) => (
//                   <Typography
//                     key={index}
//                     variant="body1"
//                     sx={{
//                       fontSize: '18px',
//                       fontWeight: 'bold',
//                       marginBottom: '8px',
//                     }}
//                   >
//                     {item.label}: {item.value}
//                   </Typography>
//                 ))}
//               </div>
//             </Grid>

//             {/* Right Section - Robot Map */}
//             <Grid item xs={12} md={6}>
//               <div
//                 ref={divRef}
//                 style={{
//                   position: 'relative',
//                   width: '100%',
//                   paddingBottom: '100%',
//                   maxWidth: '500px',
//                   margin: '0 auto', // Center the map horizontally
//                   overflow: 'hidden',
//                   border: '1px solid #ccc',
//                   borderRadius: '10px',
//                   backgroundColor: '#f9f9f9',
//                 }}
//               >
//                 <img
//                   alt="Robot Map"
//                   src={`data:image/jpeg;base64, ${map_image}`}
//                   style={{
//                     position: 'absolute',
//                     top: '0',
//                     left: '0',
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'contain',
//                   }}
//                 />
//                 {/* Robot Indicator */}
//                 {robot_status?.LocationX !== undefined &&
//                 robot_status?.LocationY !== undefined ? (
//                   (() => {
//                     const originalMapWidth = 2000; // Replace with actual map dimensions
//                     const originalMapHeight = 2000;
//                     const displayedMapWidth = divRef.current?.offsetWidth || 500;
//                     const displayedMapHeight =
//                       (displayedMapWidth / originalMapWidth) * originalMapHeight;

//                     const scaledX =
//                       (robot_status.LocationX / originalMapWidth) * displayedMapWidth;
//                     const scaledY =
//                       (robot_status.LocationY / originalMapHeight) * displayedMapHeight;

//                     return (
//                       <div
//                         style={{
//                           position: 'absolute',
//                           left: `${scaledX}px`,
//                           top: `${scaledY}px`,
//                           transform: 'translate(-50%, -50%)',
//                           backgroundColor: '#FF0000',
//                           border: '2px solid #000',
//                           borderRadius: '50%',
//                           height: '15px',
//                           width: '15px',
//                           zIndex: 9999,
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           color: '#FFF',
//                           fontSize: '10px',
//                         }}
//                       >
//                         {robot?.info?.RobotId || '?'}
//                       </div>
//                     );
//                   })()
//                 ) : (
//                   <Typography
//                     variant="body2"
//                     color="error"
//                     align="center"
//                     sx={{ marginTop: '10px' }}
//                   >
//                     No valid location data available
//                   </Typography>
//                 )}
//               </div>
//             </Grid>
//           </Grid>
//         </Card>
//       </Grid>
//     </Grid>
//   </Box>
// )}



//                {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
//                     <Card title={<p className={styles.font} style={{ fontSize: 30}}>Robot Maps</p>}>
//                     <Grid container spacing={3}>
//                         {
//                             robot_maps.map((m, i) =>{
//                                 return(
//                                     <Grid key={i} item xs={6} sm={6} md={6} lg={6} xl={6}>
//                                         <img alt={m.MapName} src={`data:image/jpeg;base64, ${m.Base64}`} ></img>
//                                     </Grid>
//                                 )
//                             })
//                         }
//                     </Grid>
//                     </Card>
//                 </Grid> */}

// {tabValue === 2 && (
//   <Box
//     p={3}
//     sx={{
//       display: 'flex',
//       justifyContent: 'center', // Centers horizontally
//       width: '100%',
//     }}
//   >
//     {/* Robot Stream */}
//     <Grid
//       container
//       spacing={3}
//       sx={{
//         maxWidth: '600px', // Limit the width for larger screens
//         width: '100%',
//         textAlign: 'center', // Center-align text
//       }}
//     >
//       <Grid item xs={12}>
//         <Card
//           sx={{
//             padding: '20px',
//             borderRadius: '12px',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//           }}
//         >
//           <Typography
//             variant="h4"
//             gutterBottom
//             sx={{ fontWeight: 'bold', fontSize: { xs: 24, sm: 28, md: 36 } }}
//           >
//             Robot Stream
//           </Typography>
//           <Grid container spacing={3} justifyContent="center">
//             {start_livestream &&
//               livestream_info.length > 0 &&
//               livestream_info.map((info, index) => (
//                 <Grid item key={index} xs={12} sm={6} md={3}>
//                   <iframe
//                     src={info.Url}
//                     style={{
//                       width: '100%',
//                       height: '200px',
//                       border: 'none',
//                       borderRadius: '8px',
//                     }}
//                   />
//                   <div>{info.CameraPosition}</div>
//                 </Grid>
//               ))}
//           </Grid>
//           <Grid item xs={12} sx={{ marginTop: '20px' }}>
//             <Button
//               onClick={props.handleStartLivestream}
//               sx={{ margin: '10px' }}
//             >
//               Start Livestream
//             </Button>
//             <Button
//               onClick={props.handleStopLivestream}
//               sx={{ margin: '10px' }}
//             >
//               Stop Livestream
//             </Button>
//           </Grid>
//         </Card>
//       </Grid>
//     </Grid>
//   </Box>
// )}


//       {tabValue === 3 && (
//         <Box p={3} >
//           {/* Pilot */}
//           <Grid container spacing={3}>
//             <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
//               <Card title={<p style={{ fontSize: 30 }}>Pilot</p>}>
//                 <Grid container spacing={3}>
//                   <div style={{ height: "100%", width: "100%", background: "white", display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: "column", flex: 0.33 }}>
//                     <button style={{ height: "100%", width: "100%" }} onPointerDown={props.handleFront} onPointerUp={props.handleStop}>Front</button>
//                   </div>
//                   <div style={{ height: "100%", width: "100%", background: "yellow", display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: "row", flex: 0.33 }}>
//                     <div style={{ height: "100%", width: "100%", display: "flex", alignItems: 'center', justifyContent: "center", flex: 0.5 }}>
//                       <button style={{ height: "100%", width: "100%" }} onPointerDown={props.handleLeft} onPointerUp={props.handleStop}>Left</button>
//                     </div>
//                     <div style={{ height: "100%", width: "100%", display: "flex", alignItems: 'center', justifyContent: "center", flex: 0.5 }}>
//                       <button style={{ height: "100%", width: "100%" }} onPointerDown={props.handleRight} onPointerUp={props.handleStop}>Right</button>
//                     </div>
//                   </div>
//                   <div style={{ height: "100%", width: "100%", background: "blue", display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: "column", flex: 0.33 }}>
//                     <button style={{ height: "100%", width: "100%" }} onPointerDown={props.handleBack} onPointerUp={props.handleStop}>Back</button>
//                   </div>
//                   <div style={{ height: "100%", width: "100%", background: "white", display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: "column", flex: 0.5 }}>
//                     <TextField id="outlined-basic" label="Broadcast Message" variant="outlined" value={props.broadcast_message} onChange={props.handleBroadcastChange} />
//                     <Button onClick={props.handleBroadcastMessage}>Broadcast</Button>
//                     <div>Selected waypoints: {props.selected_waypoint}</div>
//                     <select value={props.selected_waypoint} onChange={props.handleWaypointChange}>
//                       {waypoints.map((waypoint, index) => (
//                         <option value={waypoint.WaypointName} key={index}>{waypoint.WaypointName}</option>
//                       ))}
//                     </select>
//                     <button onClick={handleGoWaypoint}>Go to waypoint</button>
//                     <button onClick={handlePause}>Pause</button>
//                     <button onClick={handleResume}>Resume</button>
//                     <button onClick={handleStop}>Stop</button>
//                   </div>
//                 </Grid>
//               </Card>
//             </Grid>
//           </Grid>
//         </Box>
//       )}

//       {tabValue === 4 && (
//         <Box p={3}>
//           {/* Missions */}
//           <Grid container spacing={0}>
//             <Tasks />
//             <Tasklists />
//             <Missions robotId={robot.info.Id} />
//           </Grid>
//         </Box>
//       )}

//       {tabValue === 5 && (
//         <Box p={3}>
//           {/* Schedules */}
//           <Grid container spacing={0}>
//             <Grid item xs={6}>
//               <p style={{ fontSize: 20 }}>Schedule Through RMF</p>
//               <MissionScheduler robotId={robot.info.Id} />
//             </Grid>
//             <Grid item xs={6}>
//               <p style={{ fontSize: 20 }}>Schedule Through RC2</p>
//               <MissionSchedulerRC2 robotId={robot.info.Id} />
//             </Grid>
//           </Grid>
//         </Box>
//       )}

//      </Grid>

//     )
// }
